import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  clearImagePrompt,
  generateImage,
  setImagePromptText,
  setOverlay,
} from '../../store/editor.actions';
import { selectImagePrompt } from '../../store/selector/editor.selector';
import { CanvasService } from '../../../services/canvas/canvas.service';
import { ShapeService } from '../../shape/shape.service';

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64data = reader.result as string;
      resolve(base64data);
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob); // This will give you a data URL: "data:image/png;base64,..."
  });
}

@Component({
  selector: 'image-prompt-panel',
  templateUrl: './image-prompt-panel.component.html',
  styleUrls: ['./image-prompt-panel.component.scss'],
})
export class ImagePromptPanelComponent implements OnInit {
  @ViewChild('prompt') promptElement: ElementRef;

  text: string;

  base64: string;

  imagePrompt$ = this.store.select(selectImagePrompt);
  constructor(
    private store: Store,
    private cs: CanvasService,
    private shapeService: ShapeService,
  ) {
    // this.store.select(selectGeneratedImage).subscribe(blob => {
    //   // console.log('------ blob ------', blob);
    //   if (blob) {
    //     const imageUrl = URL.createObjectURL(blob);
    //     this.generatedImageUrl = imageUrl;
    //   }
    // });
    this.imagePrompt$.subscribe(async imagePrompt => {
      this.text = imagePrompt.prompt;
      if (imagePrompt.imageBlob) {
        this.base64 = await blobToBase64(imagePrompt.imageBlob);
      }
    });
  }

  ngAfterViewInit(): void {
    this.promptElement.nativeElement.focus();
  }

  ngOnInit(): void {
    // -- // -- //
    // console.log('image-prompt-panel > ngOnInit');
    // -- // -- //
  }

  enter(event: Event) {
    // -- // -- //
    if (this.cs.isShiftPressed) {
      return;
    }
    event.preventDefault();
    const text = (event.target as HTMLTextAreaElement).value;
    console.log('text', text, 'endsWith', text.endsWith('\n'));
    this.store.dispatch(setImagePromptText({ text: text.trim() }));
    this.promptElement.nativeElement.blur();
    this.generateImage(text);
  }

  addImage() {
    this.shapeService.addImageShapeByBase64(this.base64);
    this.store.dispatch(setOverlay({ value: null }));
  }

  discard() {
    this.store.dispatch(setOverlay({ value: null }));
    this.store.dispatch(clearImagePrompt());
  }

  hoveredButton: 'discard' | 'add' = null;
  hoverButton(type: 'discard' | 'add') {
    this.hoveredButton = type;
  }

  unhoverButton() {
    this.hoveredButton = null;
  }

  updateText(event: Event) {
    const text = (event.target as HTMLTextAreaElement).value;
    console.log('update-text', text, 'endsWith', text.endsWith('\n'));
    this.store.dispatch(setImagePromptText({ text }));
  }
  generateImage(prompt: string) {
    // | '3d-model'
    // | 'analog-film'
    // | 'anime'
    // | 'cinematic'
    // | 'comic-book'
    // | 'digital-art'
    // | 'enhance'
    // | 'fantasy-art'
    // | 'isometric'
    // | 'line-art'
    // | 'low-poly'
    // | 'modeling-compound'
    // | 'neon-punk'
    // | 'origami'
    // | 'photographic'
    // | 'pixel-art'
    // | 'tile-texture';

    this.store.dispatch(
      generateImage({
        prompt,
        style: 'anime',
        imageFile: this.cs.uploadeFile,
      }),
    );
  }
}
